import ConsentDefaults from 'constants/consentDefaults'

import shouldAutoGrant from 'utils/shouldAutoGrant'


export default function makeDefaultTermlyConsents() {
  if ( shouldAutoGrant() ) {
    return ConsentDefaults.OPT_OUT
  }

  return ConsentDefaults.OPT_IN
}
